import { render } from "./Registered.vue?vue&type=template&id=a5073d4c&scoped=true"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"

import "./Registered.vue?vue&type=style&index=0&id=a5073d4c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5073d4c"]])

export default __exports__